/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const general = r => require.ensure([], () => r(require('./components/manage/edit/general')), 'setting');
const usermanagement = r => require.ensure([], () => r(require('./components/manage/edit/usermanagement')), 'setting');
const directlearning = r => require.ensure([], () => r(require('./components/manage/edit/directlearning')), 'setting');
const directlearning_recipient = r => require.ensure([], () => r(require('./components/manage/edit/directlearning_recipient')), 'setting');
const campaign = r => require.ensure([], () => r(require('./components/manage/edit/campaign')), 'setting');
const email = r => require.ensure([], () => r(require('./components/manage/edit/email')), 'setting');
const credentials = r => require.ensure([], () => r(require('./components/manage/edit/credentials')), 'setting');
const landing = r => require.ensure([], () => r(require('./components/manage/edit/landing')), 'setting');
const adform = r => require.ensure([], () => r(require('./components/manage/edit/adform')), 'setting');
const listad = r => require.ensure([], () => r(require('./components/manage/edit/listad')), 'setting');
const adlogs = r => require.ensure([], () => r(require('./components/manage/edit/adlogs')), 'setting');
const alladlogs = r => require.ensure([], () => r(require('./components/manage/edit/alladlogs')), 'setting');
const oopspage = r => require.ensure([], () => r(require('./components/manage/edit/landing_oops')), 'setting');
//const trainingmail = r => require.ensure([], () => r(require('./components/manage/edit/training_mail')), 'setting');
const trainingmail = r => require.ensure([], () => r(require('./components/manage/edit/reminder_template')), 'setting');
const dl_invitation_mail = r => require.ensure([], () => r(require('./components/manage/edit/dl_invitation_mail')), 'setting');
const dl_login_link_mail = r => require.ensure([], () => r(require('./components/manage/edit/dl_login_link_mail')), 'setting');
const dl_login_with_password_mail = r => require.ensure([], () => r(require('./components/manage/edit/dl_login_with_password_mail')), 'setting');
const security = r => require.ensure([], () => r(require('./components/manage/edit/security')), 'setting');
const azure = r => require.ensure([], () => r(require('./components/manage/edit/sso/azure')), 'setting');
// appCredentials
const appCredentials = r => require.ensure([], () => r(require('./components/manage/apps/appCredentials')), 'setting');
const O365Setup = r => require.ensure([], () => r(require('./components/manage/apps/o365Setup')), 'setting');
// const MSSQL_directory = r => require.ensure([], () => r(require('./components/manage/edit/mssql_directory')), 'setting');
const books = r => require.ensure([], () => r(require('./components/manage/booklist')), 'setting');
//const bookEdit = r => require.ensure([], () => r(require('./components/manage/edit/editbook')), 'setting');
const changepassword = r => require.ensure([], () => r(require('./components/manage/edit/changepassword')), 'setting');
const bulkeducation = r => require.ensure([], () => r(require('./components/manage/bulkeducation/booklist')), 'setting');
const point_configure = r => require.ensure([], () => r(require('./components/manage/edit/point_configure')), 'setting');
const reminder = r => require.ensure([], () => r(require('./components/manage/edit/reminder')), 'setting');
const leaderboardsetting = r => require.ensure([], () => r(require('./components/manage/edit/leaderboardsetting')), 'setting');
const welcome_mail = r => require.ensure([], () => r(require('./components/manage/edit/welcome_mail')), 'setting');
const trainingmodule = r => require.ensure([], () => r(require('./components/manage/edit/trainingmodule')), 'setting');
const trainingModuleAdmin = r => require.ensure([], () => r(require('./components/manage/edit/trainingModuleAdmin')), 'setting');
const master_landing = r => require.ensure([], () => r(require('./components/manage/edit/master_landing')), 'setting');
const reminder_template = r => require.ensure([], () => r(require('./components/manage/edit/reminder_template')), 'setting');
const throttling_sending_speed = r => require.ensure([], () => r(require('./components/manage/throttling_sending_speed')), 'setting');
const courses = r => require.ensure([], () => r(require('./components/manage/courses')), 'setting');
const training_settings = r => require.ensure([], () => r(require('./components/manage/edit/training_settings')), 'setting');
const import_reporters = r => require.ensure([], () => r(require('./components/manage/edit/import_reporters')), 'setting');
const ImportTrainedUsers = r => require.ensure([], () => r(require('./components/manage/edit/import_trained_users')), 'setting');
const ExternalTrainingModules = r => require.ensure([], () => r(require('./components/manage/edit/external_training_modules')), 'setting');
const Notifications = r => require.ensure([], () => r(require('./components/manage/edit/notifications')), 'setting');
const SystemAlerts = r => require.ensure([], () => r(require('./components/manage/edit/system_alerts')), 'setting');
const IgnoreList = r => require.ensure([], () => r(require('./components/manage/edit/ignore_list')), 'setting');
const AddSource = r => require.ensure([], () => r(require('./components/manage/edit/add_source')), 'setting');
const UpdateLog = r => require.ensure([], () => r(require('./components/manage/edit/update_log')), 'setting');
const IgnoredActivities = r => require.ensure([], () => r(require('./components/manage/edit/ignored_activities')), 'setting');
const SuppressionList = r => require.ensure([], () => r(require('./components/manage/edit/suppression_list')), 'setting');
const Personlaization = r => require.ensure([], () => r(require('./components/manage/edit/personlaization')), 'setting');
const manageSmtp = r => require.ensure([], () => r(require('./components/manage/edit/manage_smtp')), 'setting');
const manageSmtpDomains = r => require.ensure([], () => r(require('./components/manage/edit/manage_smtp_domains')), 'setting');
const manageLandingPageDomains = r => require.ensure([], () => r(require('./components/manage/edit/manage_landing_page_domains')), 'setting');
const customizeAdminLogin = r => require.ensure([], () => r(require('./components/manage/edit/customize_admin_login')), 'setting');
const notificationDescription = r => require.ensure([], () => r(require('./components/manage/edit/notificationDescription')), 'setting');
const aiSettings  = r => require.ensure([], () => r(require('./components/manage/edit/ai_setting')), 'setting');
const pdfCampaign  = r => require.ensure([], () => r(require('./components/manage/edit/pdf_campaign')), 'setting');
const campaignUserRole  = r => require.ensure([], () => r(require('./components/manage/edit/campaign_user_role')), 'setting');
const training_languages = r => require.ensure([], () => r(require('./components/manage/edit/training_languages')), 'setting');
export default [
    {
        name: 'notificationDescription',
        path: '/notification/:id',
        component: notificationDescription,
    },
    {
        name: 'customizeAdminLogin',
        path: '/setting/customize-admin-login',
        component: customizeAdminLogin,
    },
    {
        name: 'courses',
        path: '/setting/courses',
        component: courses,
    },
    {
        name: 'general',
        path: '/setting/general',
        component: general,
    },
    {
        name: 'throttling_sending_speed',
        path: '/setting/throttling_sending_speed',
        component: throttling_sending_speed,
    },
    {
        name: 'master_landing',
        path: '/setting/master_landing',
        component: master_landing,
    },
    {
        name: 'trainingmoduleAdmin',
        path: '/trainingmoduleAdmin',
        component: trainingModuleAdmin,
    },
    {
        name: 'training_languages',
        path: '/setting/training-languages',
        component: training_languages,
    },
    {
        name: 'trainingmodule',
        path: '/trainingmodule',
        component: trainingmodule,
    },
    {
        name: 'leaderboardsetting',
        path: '/setting/leaderboardsetting',
        component: leaderboardsetting,
    },
    {
        name: 'usermanagement',
        path: '/setting/usermanagement',
        component: usermanagement,
    },
    {
        name: 'directlearning',
        path: '/setting/directlearning',
        component: directlearning,
    },
    {
        name: 'directlearning_recipient',
        path: '/setting/directlearning/:id/:type',
        component: directlearning_recipient,
    },
    {
        name: 'retest',
        path: '/setting/campaign',
        component: campaign,
    },
    {
        name: 'email',
        path: '/setting/email',
        component: email,
    },
    {
        name: 'credentials',
        path: '/setting/reply-to-credentials',
        component: credentials,
    },
    {
        name: 'landing',
        path: '/setting/landing',
        component: landing,
    },
    {
        name: 'adform',
        path: '/setting/adform',
        component: adform,
    },
    {
         name: 'listad',
         path: '/setting/listad',
         component: listad,
    },
    {
        name: 'adlogs',
        path: '/setting/adlogs/:id',
        component: adlogs,
    },
    {
        name: 'alladlogs',
        path: '/setting/alladlogs',
        component: alladlogs,
    },
    {
        name: 'oopspage',
        path: '/setting/oopspage',
        component: oopspage,
    },
    {
        name: 'trainingmail',
        path: '/setting/trainingmail',
        component: trainingmail,
    },
    {
        name: 'dl_invitation_mail',
        path: '/setting/dl_invitation_mail',
        component: dl_invitation_mail,
    },
    {
        name: 'dl_login_link_mail',
        path: '/setting/dl_login_link_mail',
        component: dl_login_link_mail,
    },
    {
        name: 'dl_login_link_mail',
        path: '/setting/dl_login_link_mail',
        component: dl_login_link_mail,
    },
    {
        name: 'dl_login_with_password_mail',
        path: '/setting/dl_login_with_password_mail',
        component: dl_login_with_password_mail,
    },
    {
        name: 'notifications',
        path: '/settings/notifications',
        component: Notifications,
    },
    {
        // Configuration alerts. Must also be whitelisted in utils/permissions.js
        // or beforeEach silently bounces it to the dashboard.
        name: 'systemAlerts',
        path: '/settings/system-alerts',
        component: SystemAlerts,
    },
    {
        name: 'ignore_list',
        path: '/settings/ignore-list',
        component: IgnoreList,
    },
    {
        name: 'add_source',
        path: '/settings/ignore-list/add-source',
        component: AddSource,
    },
    {
        name: 'update_log',
        path: '/settings/ignore-list/audit-log',
        component: UpdateLog,
    },
    {
        name: 'ignored_activities',
        path: '/settings/ignore-list/ignored-activities',
        component: IgnoredActivities,
    },
    {
        name: 'suppression_list',
        path: '/settings/ignore-list/suppression-logs',
        component: SuppressionList,
    },
    {
        name: 'personlaization',
        path: '/settings/personlaization',
        component: Personlaization,
    },
    {
        name: 'security',
        path: '/setting/security',
        component: security,
    },
    {
        name: 'azure',
        path: '/setting/azure',
        component: azure,
    },
    {
        name: 'appCredentials',
        path: '/setting/channel-credentials',
        component: appCredentials,
    },
    {
        name: 'O365Setup',
        path: '/setting/O365Setup',
        component: O365Setup,
    },
    {
        name: 'aiSettings',
        path: '/settings/ai-setting',
        component: aiSettings,
    },

    // {
    //     name: 'MSSQLdirectory',
    //     path: '/setting/MSSQL_directory',
    //     component: MSSQL_directory,
    // },
    {
        name: 'books',
        path: '/setting/books',
        component: books,
    },
    {
        name: 'changepassword',
        path: '/setting/changepassword',
        component: changepassword,
    },
    {
        name: 'bulkeducation',
        path: '/bulkeducation',
        component: bulkeducation,
    },
    {
        name: 'point_configure',
        path: '/setting/point_configure',
        component: point_configure,
    },
    {
        name: 'reminder',
        path: '/setting/reminder',
        component: reminder,
    },
    {
        name: 'welcome_mail',
        path: '/setting/welcome_mail',
        component: welcome_mail,
    },
    {
        name: 'training_settings',
        path: '/training_settings',
        component: training_settings,
    },
    {
        name: 'import_reporters',
        path: '/import_reporters',
        component: import_reporters,
    },
    {
        name: 'import_trained_users',
        path: '/settings/import-trained-users',
        component: ImportTrainedUsers,
    },
    {
        name: 'external_training_modules',
        path: '/settings/external-training-modules',
        component: ExternalTrainingModules,
    },
    {
        name: 'manage_smtp',
        path: '/settings/manage-smtp',
        component: manageSmtp,
    },
    {
        name: 'manage_smtp_domains',
        path: '/settings/manage-smtp-domains',
        component: manageSmtpDomains,
    },
    {
        name: 'manage_landing_page_domains',
        path: '/settings/manage-landing-page-domains',
        component: manageLandingPageDomains,
    },
    {
        name: 'pdfCampaign',
        path: '/settings/pdf-campaign',
        component: pdfCampaign,
    },
    {
        name: 'campaignUserRole',
        path: '/settings/campaign-user-role',
        component: campaignUserRole,
    },
]



// WEBPACK FOOTER //
// ./src/app/setting/routes.js